import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PurchasePaymentForm } from "@/features/purchase-payments";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreatePurchasePayment = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { buyerId, ...payload } = formData;

      await apiOutletClient.post("purchase-payments", payload, {
        headers: {
          "Outlet-Id": buyerId,
        },
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat pembayaran pembelian")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Pembayaran Pembelian"
      breadcrumbs={[
        { title: "Pembayaran Pembelian", path: "/procurement/purchase-payments" },
        { title: "Tambah" },
      ]}
    >
      <PurchasePaymentForm
        onSubmit={handleSubmit}
        defaultValues={{
          buyer: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
